import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const plan = () => {

	document.querySelectorAll('[data-animation="plan"]').forEach(el => {

		if (window.innerWidth < 960) return

		let steps = el.querySelectorAll('[data-step]')

		gsap.set(el, {
			height: el.offsetHeight
		})

		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: el.parentElement.parentElement,
				start: 'top 75%',
				end: 'bottom 60%',
				scrub: true,
				// markers: true,
			}
		})

		// Collapsed height: the step's header (first child) plus any border
		let upperHeight = steps[0].firstElementChild.offsetHeight + steps[0].offsetHeight - steps[0].clientHeight

		steps.forEach((step, i) => {

			tl.from(step, {
				height: upperHeight,
				duration: 1,
				ease: 'none',
			}, '-=0.2')

		})
	})
}

export default () => { }